import {
  useExternalQuoteRequestsControllerFindResponded,
  type ExternalQuoteRequestsControllerFindRespondedParams,
} from "@semo/api-contracts";

export type UseRespondedQuoteRequestsParams =
  ExternalQuoteRequestsControllerFindRespondedParams;

export function useRespondedQuoteRequests(
  params: UseRespondedQuoteRequestsParams = { page: 1, limit: 20 },
) {
  return useExternalQuoteRequestsControllerFindResponded(params);
}
